import { render, staticRenderFns } from "./damage_shortage.vue?vue&type=template&id=5bfa9162"
import script from "./damage_shortage.vue?vue&type=script&lang=js"
export * from "./damage_shortage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports